import { Repeat2, ShoppingBasket, Tags, Users } from "lucide-react";
import { useI18n } from "../i18n";
import { InterestForm } from "./InterestForm";
import { TopographicLines } from "./TopographicLines";

const measureIcons = [
  Users,
  Tags,
  ShoppingBasket,
  Repeat2
] as const;

export function ValidationSection() {
  const { messages } = useI18n();

  return (
    <section id="interest" className="validation section" aria-labelledby="validation-title">
      <TopographicLines className="validation__contours" />
      <div className="shell validation__grid">
        <div className="validation__copy">
          <h2 id="validation-title">{messages.validation.title}</h2>
          <p className="validation__lede">{messages.validation.lede}</p>
          <div className="measure-list">
            <h3>{messages.validation.measuresTitle}</h3>
            {measureIcons.map((Icon, index) => {
              const label = messages.validation.measures[index] ?? "";
              return (
              <div className="measure-row" key={label}>
                <Icon aria-hidden="true" />
                <span>{label}</span>
                <span className="measure-row__rail" aria-hidden="true">
                  <i />
                </span>
              </div>
              );
            })}
          </div>
          <div className="signal-note">
            <strong>{messages.validation.usefulSignalTitle}</strong>
            <p>{messages.validation.usefulSignalBody}</p>
          </div>
        </div>
        <InterestForm />
      </div>
    </section>
  );
}
